import { View } from "aws-sdk/clients/connect";
import { AlignContent, Corners, FooterType, FooterTypes, HeaderButtonStyle, ImageFit, ImageRatio, TextPosition, headlineAnimationType, logoDirection, logoSpeed, logoType, showCaseType } from "simpo-component-library";
import { BACKGROUND_ANIMATION, CARD_SIZE, CONTENT_ANIMATION, CONTENT_BACKGROUND, FIT, GRID_STYLE, LOGO_POSITION, MAP_STYLE, PRICING_STYLE, PROCESS_SECTION_DISPLAY_STYLE, SPACING_TYPE } from "simpo-component-library/lib/styles/types";


interface genericType<T> {
  type: T;
  icon?: string;
  activeIcon?: string;
}
interface type {
  type: string;
  view?: string;
  rx?: number;
}
interface spacingType {
  type: SPACING_TYPE;
  view?: string;
}
export const contentAnimation: Array<genericType<CONTENT_ANIMATION>> = [
  { type: "hover-pop" },
  { type: "slide-in-left" },
  { type: "none" }
]
export const headlineanimationType: Array<type> = [
  {
    type: headlineAnimationType.INFINITE_SCROLL
  },
  {
    type: headlineAnimationType.SOFT_TRANSITION
  },
  {
    type: headlineAnimationType.NO_EFFECT
  }
]

export const imageFit: Array<type> = [
  {
    type: ImageFit.Cover
  }
  ,
  {
    type: ImageFit.Contain
  }
];

interface ratioType {
  key: string;
  value: string;
  rect: { x: number; y: number; w: number; h: number };
}
export const aspectRatio: Array<ratioType> = [
  {
    key: 'square',
    value: ImageRatio.SQUARE,
    rect: { x: 4, y: 4, w: 16, h: 16 }
  },
  {
    key: 'portrait',
    value: ImageRatio.PORTRAIT,
    rect: { x: 6, y: 2, w: 12, h: 20 }
  },
  {
    key: 'landscape',
    value: ImageRatio.LANDSCAPE,
    rect: { x: 2, y: 5, w: 20, h: 14 }
  },
  {
    key: 'widescreen',
    value: ImageRatio.WIDESCREEN,
    rect: { x: 1, y: 6, w: 22, h: 12 }
  }
]

export const corners: Array<type> = [
  {
    type: Corners.None,
    rx: 0
  },
  {
    type: Corners.Small,
    rx: 3
  },
  {
    type: Corners.Medium,
    rx: 7
  },
  {
    type: Corners.Large,
    rx: 14
  }
]


export const cardSize: Array<genericType<CARD_SIZE>> = [
  {
    type: 'Small'
  },
  {
    type: 'Medium'
  },
  {
    type: 'Large'
  }
]
export const gridStyle: Array<genericType<GRID_STYLE>> = [
  {
    type: 'Style1',
  },
  {
    type: 'Style2'
  }
]
export const logoPosition: Array<genericType<LOGO_POSITION>> = [
  {
    type: "left",
  },
  {
    type: "right",
  },
  {
    type: "bottom",
  },
  {
    type: "top"
  }
]
export const textPosition: Array<type> = [
  {
    type: TextPosition.BELOW_IMAGE
  },
  {
    type: TextPosition.TOP_OF_IMAGE
  },
  {
    type: TextPosition.COVERING_IMAGE
  }
]

export const animationType: Array<type> = [
  { type: 'left', view: 'Slide left' },
  { type: 'top', view: 'Slide up' },
  { type: 'right', view: 'Slide right' },
  { type: 'bottom', view: 'Slide down' },
  { type: 'fadeIn', view: 'fade In' },
  { type: 'zoom', view: 'Zoom In' },
]

export const animationSpeed: Array<type> = [
  { type: 'slow' },
  { type: 'medium' },
  { type: 'fast' },
];

export const productCardTheme: Array<type> = [
  { type: 'Theme1' },
  { type: 'Theme2' }
];

export const spacingType: Array<spacingType> = [
  { type: 'none', view: 'XS' },
  { type: 'small', view:'S' },
  { type: 'medium', view: 'M' },
  { type: 'large', view: 'L' },
  { type: 'remove', view: 'None' }
]

export const minHeight: Array<genericType<FIT>> = [
  {
    type: 'content',
    icon: '',
    activeIcon: ''
  },
  {
    type: 'screen',
    icon: '',
    activeIcon: ''
  }
]
export const flexWrapOptions: string[] = ["ROW", "COLUMN"];
export const headerStyling: string[] = ["Header1", "Header2", "Header3", "Header4"];

export const menuType: string[] = ['MEGA_MENU', 'DROPDOWN_MENU']

export const borderType: Array<type> = [
  { type: 'DASHED' },
  { type: 'SOLID' }
]

export const contentAlignment: Array<type> = [
  {
    type: AlignContent.Image_TOP
  },
  {
    type: AlignContent.Image_CENTER
  },
  {
    type: AlignContent.Image_BOTTOM
  }
]

export const footerType: Array<type> = [
  {
    type: FooterType.FOOTER_1,
  },
  {
    type: FooterType.FOOTER_2
  },
  {
    type: FooterType.FOOTER_3
  },
  {
    type: FooterType.FOOTER_4
  },
  // {
  //   type: FooterTypes.STACKED_DETAILS_CENTER
  // },
  // {
  //   type: FooterTypes.STACKED_DETAILS_LEFT
  // },
  // {
  //   type: FooterTypes.STACKED_DETAILS_RIGHT
  // }
]

export const navigationStyle: Array<type> = [
  {
    type: HeaderButtonStyle.ROUND_BOLD
  },
  {
    type: HeaderButtonStyle.ROUND_SUBTLE
  },
  {
    type: HeaderButtonStyle.SQUARE_BOLD
  },
  {
    type: HeaderButtonStyle.SQUARE_SUBTLE
  },
  {
    type: HeaderButtonStyle.TAB
  }
]

export const backgroundAnimation: Array<genericType<BACKGROUND_ANIMATION>> = [
  {
    type: 'ABSTRACT'
  },
  {
    type: 'DANCING_DOTS'
  },
  {
    type: 'DOTS'
  },
  {
    type: 'DREW'
  },
  {
    type: 'NONE'
  },
  {
    type: 'SCATTERING_DOTS'
  },
  {
    type: 'WAVES'
  }
]

export const mapStyle: Array<genericType<MAP_STYLE>> = [
  {
    type: "Dark"
  },
  {
    type: 'Light'
  },
  {
    type: 'Outdoors'
  },
  {
    type: 'Satellite'
  },
  {
    type: 'Satellite_street'
  },
  {
    type: 'Streets'
  },
  {
    type: 'navigation_day'
  },
  {
    type: 'navigation_night'
  }
]

export const showCaseTypeArray: Array<type> = [
  {
    type: showCaseType.Carousal
  },
  {
    type: showCaseType.Grid
  }
]

export const processSectionStyle: Array<genericType<PROCESS_SECTION_DISPLAY_STYLE>> = [
  {
    type: 'STYLE1'
  },
  {
    type: 'STYLE2'
  }
]

export const componentStyles: Array<type> = [
  { type: 'Style1' },
  { type: 'Style2' },
];

export const pricingStyleType: Array<genericType<PRICING_STYLE>> = [
  {
    type: 'STYLE1'
  },
  {
    type: 'STYLE2'
  }
]

export const contentBackgroundType: Array<genericType<CONTENT_BACKGROUND>> = [
  {
    type: 'black'
  },
  {
    type: 'white'
  }
]
export const carouselSpeed: Array<type> = [
  {
    view: "Normal",
    type: "3s"
  },
  {
    view: "Slow",
    type: "4s"
  },
  {
    view: "Fast",
    type: "2s"
  },
  {
    view: "Very Fast",
    type: "1s"
  }
]

export const logoCarouselDirection: Array<type> = [
  {
    type: logoDirection.Left
  },
  {
    type: logoDirection.Right
  }
]

export const logoBoxType: Array<type> = [
  {
    type: logoType.Basic
  },
  {
    type: logoType.Boxed
  }
]

export const OverLay: Array<type> = [
  {
    type: 'NONE'
  },
  {
    type: 'LIGHT'
  },
  {
    type: 'MODERATE'
  },
  {
    type: 'STRONG'
  },
  {
    type: 'VERY_STRONG'
  }
]
